import{SET_USER_GEOLOCATION}from"../constants";/**
 * @param {Object} geolocation .
 * @param {boolean} silent .
 * @returns {Object}
 */var setUserGeolocation=function setUserGeolocation(geolocation,silent){return{type:SET_USER_GEOLOCATION,geolocation:geolocation,silent:silent};};export default setUserGeolocation;